module.exports = __webpack_public_path__ + "media/assets/certification_page/communitea-ee0608bbb460699540d5028f725de08c7161f8621c9226a01276ccca01edc3dd.png";